import React from 'react'
import PropTypes from 'prop-types'
import { IconSLI60Wrapper } from './IconSLI60Wrapper'

export const Icon60EmailSend = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLI60Wrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 47.875 29.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M47.889,4.189 L45.225,25.942 C44.992,28.117 43.055,29.898 40.909,29.898 L13.969,29.898 C13.418,29.898 12.971,29.452 12.971,28.902 C12.971,28.352 13.418,27.906 13.969,27.906 L40.909,27.906 C42.046,27.906 43.114,26.903 43.241,25.716 L45.903,3.986 L26.555,18.734 C26.374,18.871 26.161,18.938 25.949,18.938 C25.672,18.938 25.397,18.823 25.200,18.601 L10.227,1.662 C10.160,1.586 10.121,1.497 10.081,1.410 C10.073,1.395 10.063,1.383 10.057,1.368 C10.024,1.286 10.013,1.204 10.003,1.118 C9.997,1.078 9.977,1.045 9.977,1.003 C9.977,0.992 9.983,0.983 9.984,0.972 C9.986,0.899 10.009,0.830 10.027,0.758 C10.041,0.703 10.046,0.646 10.070,0.595 C10.093,0.542 10.134,0.499 10.166,0.451 C10.207,0.391 10.243,0.330 10.296,0.280 C10.304,0.273 10.307,0.262 10.315,0.255 C10.353,0.221 10.401,0.209 10.442,0.182 C10.502,0.143 10.558,0.102 10.625,0.077 C10.693,0.051 10.762,0.045 10.833,0.035 C10.882,0.027 10.925,0.006 10.976,0.006 L43.903,0.006 C45.042,0.006 46.181,0.515 46.949,1.369 C47.665,2.165 47.999,3.165 47.889,4.189 ZM44.000,1.940 L13.135,1.940 L26.082,16.585 L44.913,2.233 C44.639,2.056 44.337,1.940 44.000,1.940 ZM10.976,9.970 C10.976,10.521 10.529,10.967 9.977,10.967 L3.988,10.967 C3.437,10.967 2.990,10.521 2.990,9.970 C2.990,9.420 3.437,8.973 3.988,8.973 L9.977,8.973 C10.529,8.973 10.976,9.420 10.976,9.970 ZM13.970,15.949 C13.970,16.499 13.523,16.946 12.972,16.946 L0.994,16.946 C0.442,16.946 -0.005,16.499 -0.005,15.949 C-0.005,15.398 0.442,14.952 0.994,14.952 L12.972,14.952 C13.523,14.952 13.970,15.398 13.970,15.949 ZM6.983,20.931 L16.965,20.931 C17.516,20.931 17.963,21.377 17.963,21.927 C17.963,22.478 17.516,22.924 16.965,22.924 L6.983,22.924 C6.432,22.924 5.985,22.478 5.985,21.927 C5.985,21.377 6.432,20.931 6.983,20.931 Z'
        />
      </svg>
    </IconSLI60Wrapper>
  )
}

Icon60EmailSend.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
